import { Destroyable } from './Destroyable.js';
import { EventEmitterMixin } from './EventEmitterMixin';
import * as GUID from './GUID';

const _cn = Symbol();
const _distinguishedName = Symbol();
const _objectGUID = Symbol();
const _primaryGroupID = Symbol();
const _sAMAccountName = Symbol();
const _appServerDoctorId = Symbol();
const _mail = Symbol();
const _appServerAlertsEmail = Symbol();

export class Account extends EventEmitterMixin(Destroyable) {
	constructor(cn, distinguishedName, objectGUID, primaryGroupID, sAMAccountName, appServerDoctorId, mail, appServerAlertsEmail) {
		super();
		this.cn = cn;
		this.distinguishedName = distinguishedName;
		this.objectGUID = objectGUID;
		this.primaryGroupID = primaryGroupID;
		this.sAMAccountName = sAMAccountName;
		this.appServerDoctorId = appServerDoctorId;
		this.mail = mail;
		this.appServerAlertsEmail = appServerAlertsEmail;
	}
	get cn() {
		return this[_cn];
	}
	set cn(v) {
		if(v !== null && typeof v !== 'string')
			throw new TypeError('cn must be a string.');
		this[_cn] = v;
	}
	get distinguishedName() {
		return this[_distinguishedName];
	}
	set distinguishedName(v) {
		if(v !== null && typeof v !== 'string')
			throw new TypeError('distinguishedName must be a string.');
		this[_distinguishedName] = v;
	}
	get objectGUID() {
		return this[_objectGUID];
	}
	set objectGUID(v) {
		if(v !== null && (typeof v !== 'string' || !GUID.isGUID(v)))
			throw new TypeError('objectGUID must be a GUID formatted string.');
		this[_objectGUID] = v;
	}
	get primaryGroupID() {
		return this[_primaryGroupID];
	}
	set primaryGroupID(v) {
		if(v !== null && typeof v !== 'string')
			throw new TypeError('primaryGroupID must be a string.');
		this[_primaryGroupID] = v;
	}
	get sAMAccountName() {
		return this[_sAMAccountName];
	}
	set sAMAccountName(v) {
		if(v !== null && typeof v !== 'string')
			throw new TypeError('sAMAccountName must be a string.');
		this[_sAMAccountName] = v;
	}
	get appServerDoctorId() {
		return this[_appServerDoctorId];
	}
	set appServerDoctorId(v) {
		if(v !== null && !Number.isInteger(v))
			throw new TypeError('appServerDoctorId must be an integer.');
		this[_appServerDoctorId] = v;
	}
	get mail() {
		return this[_mail];
	}
	set mail(v) {
		if(v !== null && typeof v !== 'string')
			throw new TypeError('mail must be a string.');
		this[_mail] = v;
	}
	get appServerAlertsEmail() {
		return this[_appServerAlertsEmail];
	}
	set appServerAlertsEmail(v) {
		if(v !== null && typeof v !== 'string')
			throw new TypeError('appServerAlertsEmail must be a string.');
		this[_appServerAlertsEmail] = v;
	}
	load(obj) {
		if(obj === null || typeof obj !== 'object')
			throw new TypeError('obj must be an object.');
		this.cn = obj.cn || null;
		this.distinguishedName = obj.distinguishedName || null;
		this.objectGUID = obj.objectGUID || null;
		this.primaryGroupID = obj.primaryGroupID || null;
		this.sAMAccountName = obj.sAMAccountName || null;
		this.appServerDoctorId = obj.appServerDoctorId || null;
		this.mail = obj.mail || null;
		this.appServerAlertsEmail = obj.appServerAlertsEmail || null;
		this.trigger('load');
	}
	static fromObject(obj) {
		if(obj === null || typeof obj !== 'object')
			throw new TypeError('obj must be an object.');
		return new this(
			obj.cn || null,
			obj.distinguishedName || null,
			obj.objectGUID || null,
			obj.primaryGroupID || null,
			obj.sAMAccountName || null,
			obj.appServerDoctorId || null,
			obj.mail || null,
			obj.appServerAlertsEmail || null
		);
	}
}